import React, { useState } from 'react';
import { Type } from 'lucide-react';

export default function BrandNameFix({ api }) {
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState('');
  const run = async () => {
    setBusy(true); setResult('');
    try {
      const { data } = await api.post('/admin/brand-name-fix');
      const total = Object.values(data.updated || {}).reduce((a, b) => a + b, 0);
      setResult(total ? `Updated ${total} saved letter, script or setting record${total === 1 ? '' : 's'}.` : 'Everything already says "Roofs To Remedy".');
    } catch (e) {
      setResult(e.response?.data?.detail || 'Could not update. Please try again.');
    }
    setBusy(false);
  };
  return (
    <div className="bg-white border border-[#E2E2DF] rounded-md p-4 flex flex-wrap items-center gap-3" data-testid="brand-name-fix-card">
      <Type size={18} className="text-[#D35400]" />
      <p className="text-sm text-slate-700 flex-1 min-w-[240px]">Change "Roof's To Remedy" to <b>"Roofs To Remedy"</b> in saved letters, scripts and settings.</p>
      <button type="button" data-testid="brand-name-fix-btn" onClick={run} disabled={busy}
        className="px-4 py-2 rounded-md bg-[#D35400] hover:bg-[#A04000] text-white text-sm font-semibold transition-colors disabled:opacity-50">
        {busy ? 'Updating…' : 'Update saved text'}</button>
      {result && <p className="w-full text-sm text-slate-600" data-testid="brand-name-fix-result">{result}</p>}
    </div>
  );
}
